import { Button } from '@/fsd/shared/ui';
import { Checkbox } from '@/fsd/shared/ui/checkbox/checkbox';
import Loader from '@/fsd/shared/ui/Loader/Loader';
import Modal from '@/fsd/shared/ui/Modal/Modal';
import { Box } from '@mui/material';
import React, { useState } from 'react';
import { initialChecklistItems } from '../../model/consts/initialChecklistItems';
import styles from './EnteringInitialDataChecklistModal.module.scss';

interface IProps {
  open: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

export const EnteringInitialDataChecklistModal = ({
  open,
  onClose,
  onSubmit,
}: IProps) => {
  const [items, setItems] = useState(initialChecklistItems);

  const handleToggle = (id: string) => {
    setItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, checked: !item.checked } : item
      )
    );
  };

  return (
    <Modal
      showModal={open}
      setShowModal={onClose}
      showCloseButton={true}
      className={styles.onboardingModal}
      height="fit-content"
      title={
        <div className={styles.titleContainer}>
          <h2>Чек-лист ввода исходных данных</h2>
          <span className={styles.subtitle}>
            Объяснение как работает чеклист
          </span>
        </div>
      }
      footer={
        <Box className={styles.modalActions}>
          <Button
            onClick={onSubmit}
            variant="primary"
            size="l"
            className={styles.submitButton}
          >
            Запуск настройки
          </Button>
        </Box>
      }
    >
      <div className={styles.checklistList}>
        {items.map((item) => (
          <div key={item.id} className={styles.checklistItem}>
            <div className={styles.leftSection}>
              {/* Conditional styling based on item variant if needed */}
              <div
                className={`${styles.checkboxWrapper} ${
                  item.variant ? styles[item.variant] : ''
                }`}
              >
                <Checkbox
                  checked={item.checked}
                  onChange={() => handleToggle(item.id)}
                />
              </div>
              <span className={styles.itemLabel}>{item.label}</span>
            </div>

            <Loader size="small" />
          </div>
        ))}
      </div>
    </Modal>
  );
};
